module.exports = __webpack_public_path__ + "static/media/interview01_s.f2f5fe71.jpg";